<template>
  <div>   
    <registration-request-layout
      :requestId="requestId"
      :onRequestProcessed="onRequestProcessed"
      :getRegistrationRequestById="workflowService.getDogRegistrationIndividualRequestById"
      :approveRegistrationRequest="workflowService.approveDogRegistrationIndividual"
      :denyRegistrationRequest="workflowService.denyDogRegistrationIndividual"
      :cancelRegistrationRequestFn="workflowService.cancelDogRegistrationIndividual"      
      :signSignatureByAdminFn="workflowService.signDogRegistrationIndividualSignatureByAdmin"
      signatories2Header="Kennel Name Usage Signatories"
      :signSignature2ByAdminFn="workflowService.signDogRegistrationIndividualKennelNameUsageSignatureByAdmin"
      :markPaidByAdminFn="workflowService.markDogRegistrationIndividualPaidByAdmin"
      :setRegistrationData="(registration) => (this.registration = registration)"
    >      
      <div slot="registrationWarnings">
        <v-alert v-if="!!registration && !!registration.owners && registration.owners.some(o => !o.isActiveMember)" type="warning">
          <h3>Expired coowners:</h3>
          <CoownersList :owners="registration.owners" :ownershipType="dogOwnershipType" :hideHeader="true"/>
        </v-alert> 
      </div> 
      <h2 v-if=!!registration.dogId>
          <span class="blue-grey--text text--darken-1">ID#: </span>
          <router-link :to="`/admin/dogs/${encodeURIComponent(registration.dogId?.trim())}`" target="_blank">
          {{registration.dogId?.trim()}}
        </router-link>
      </h2>
      <DogRegistrationIndividualRequest :registration="registration" />
    </registration-request-layout>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import DogRegistrationIndividualRequest from "@/components/Portal/MyRequest/DogRegistrationIndividualRequest.vue";
import RegistrationRequestLayout from "@/components/common/RegistrationRequestLayout.vue";
import workflowService from "@/services/admin/workflowService";
import CoownersList, { OwnershipType } from "@/components/common/CoownersList.vue";

export default Vue.extend({
  name: "DogRegistrationIndividualRequestCard",
  props: {
    requestId: { type: Number },
  },
  components: {
    RegistrationRequestLayout,
    DogRegistrationIndividualRequest,
    CoownersList,
  },
  data: function () {
    return {
      registration: {
        workflowGuid: "",
        requestId: 0,
        dogId: null as string | null,
      } as any,
    };
  },
  computed: {
    workflowService() {
      return workflowService;
    },
    dogOwnershipType: function() {
     return OwnershipType.Dog;
    },
  },
  methods: {
    onRequestProcessed: function (requestId: number) {
      workflowService.getDogRegistrationIndividualRequestById(requestId).then((res: { data: any; }) => {
        if(!!res.data.dogId) {
          this.$navigate({ path: `/admin/dogs/${res.data.dogId?.trim()}` });
        } else {
          this.$navigate({ path: '/admin/registration/dogs/individual' });
        }
      });
    },
  },
});
</script>
